module.exports = __webpack_public_path__ + "img/odoo-for-human-resources-min.bc99a02a.png";